import React from "react";
import {authConfig} from "./Auth";
import ViewPage from "./ViewPage";

class SelfViewPage extends React.Component {

  render() {
    return (
      <ViewPage
        type={"forgotPassword"}
        applicationName={authConfig.appName}
        {...this.props}
      />
    );
  }
}

export default SelfViewPage;
